import { Banner as BannerInterface } from '@ambire-common/interfaces/banner'
import { useMemo } from 'react'
import { getCurrentAccountBanners } from '@ambire-common/libs/banners/banners'
// import useBannersControllerState from '@web/hooks/useBannersControllerState'
// import useEmailVaultControllerState from '@web/hooks/useEmailVaultControllerState'
import useExtensionUpdateControllerState from '@web/hooks/useExtensionUpdateControllerState'
import useMainControllerState from '@web/hooks/useMainControllerState'
import usePortfolioControllerState from '@web/hooks/usePortfolioControllerState/usePortfolioControllerState'
import useRequestsControllerState from '@web/hooks/useRequestsControllerState'
import useSelectedAccountControllerState from '@web/hooks/useSelectedAccountControllerState'
import useSwapAndBridgeControllerState from '@web/hooks/useSwapAndBridgeControllerState'

export default function useBanners(): BannerInterface[] {
  const OFFLINE_BANNER: BannerInterface = {
    id: 'offline-banner',
    type: 'error',
    title: 'Network Issue',
    text: 'Your network connection is too slow or you may be offline. Please check your internet connection.',
    actions: [
      {
        actionName: 'reload-selected-account',
        label: 'Retry'
      }
    ]
  }

  const { isOffline } = useMainControllerState()
  const { account, portfolio, deprecatedSmartAccountBanner } = useSelectedAccountControllerState()
  // const { banners: marketingBanners } = useBannersControllerState()

  // const { banners: emailVaultBanners = [] } = useEmailVaultControllerState()
  const { banners: requestBanners = [] } = useRequestsControllerState()
  const { banners: swapAndBridgeBanners = [] } = useSwapAndBridgeControllerState()
  const { extensionUpdateBanner } = useExtensionUpdateControllerState()
  const { hasFundedHotAccount } = usePortfolioControllerState()

  const controllerBanners = useMemo(() => {
    return [
      ...(deprecatedSmartAccountBanner || []),
      ...(requestBanners || []),
      ...(isOffline && portfolio?.isAllReady ? [OFFLINE_BANNER] : []),
      ...(isOffline ? [] : [...(swapAndBridgeBanners || [])]),
      ...getCurrentAccountBanners([], account?.addr),
      ...(extensionUpdateBanner || [])
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    deprecatedSmartAccountBanner,
    requestBanners,
    isOffline,
    portfolio?.isAllReady,
    swapAndBridgeBanners,
    hasFundedHotAccount,
    // emailVaultBanners,
    account?.addr,
    extensionUpdateBanner
  ])

  return controllerBanners
  // return [controllerBanners, marketingBanners]
}
